"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ALLOWED_HEADERS = exports.CloudflareHeaders = void 0;
var CloudflareHeaders;
(function (CloudflareHeaders) {
    CloudflareHeaders["CountryCode"] = "cf-ipcountry";
    CloudflareHeaders["Staff"] = "staff";
    CloudflareHeaders["AssistedLogin"] = "assistedLogin";
})(CloudflareHeaders = exports.CloudflareHeaders || (exports.CloudflareHeaders = {}));
exports.DEFAULT_ALLOWED_HEADERS = [
    'accept',
    'accept-language',
    'accept-patch',
    'access-control-allow-credentials',
    'access-control-allow-headers',
    'access-control-allow-methods',
    'access-control-allow-origin',
    'access-control-expose-headers',
    'access-control-max-age',
    'access-control-request-headers',
    'access-control-request-method',
    'age',
    'allow',
    'authorization',
    'cache-control',
    'connection',
    'content-disposition',
    'content-encoding',
    'content-language',
    'content-location',
    'content-range',
    'content-type',
    'date',
    'expect',
    'expires',
    'forwarded',
    'from',
    'location',
    'origin',
    'pragma',
    'range',
    'referer',
    'retry-after',
    'cookie',
    'set-cookie',
    'upgrade',
    'user-agent',
    'via',
    'warning',
    'x-forwarded-for',
    'x-real-ip',
    'x-forwarded-proto',
    'subnet',
    'locale',
    // Cloudflare related headers
    ...Object.values(CloudflareHeaders)
];
//# sourceMappingURL=constants.js.map